// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const pin: CountryValidator<"GE"> = createValidator(
  "ge.pin",
  84,
);

export default pin;
export const compact = pin.compact;
export const format = pin.format;
export const validate = pin.validate;
export const generate = (): string =>
  pin.generate?.() ??
  (() => {
    throw new Error(
      "Validator ge.pin cannot generate values",
    );
  })();
